<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['GP'][arry_aac.providerName]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <!--PGSOFT-->
                                <div v-if="arry_aac.providerName === 'PGSOFT'">
                                    <div class="modal-main-content p-0">
                                        <!--Common-->
                                        <div v-if="arry_aac.currencyCategories.some(o=>o.tag==='common')">
                                            <div>{{getLanguage["GLU"]["CM"]}}</div>
                                            <div>
                                                <span class='searchLabel'>{{getLanguage["GLU"]["LU"]}} :</span>
                                                <div class="gameLaunch1">
                                                    <div class="text-center deviceType1">{{getLanguage["GLU"]["C"]}}</div>
                                                    <div class="gameUrl1"><CInput size="sm" :value="arry_aac.currencyCategories.find(o=>o.tag==='common').desktopUrl" readonly /></div>
                                                </div>
                                                <div class="gameLaunch1">
                                                    <div class="text-center deviceType1">{{getLanguage["GLU"]["N"]}}</div>
                                                    <div class="gameUrl1"><CInput size="sm" :value="arry_aac.currencyCategories.find(o=>o.tag==='common').newDesktopUrl" @change="v => arry_aac.currencyCategories.find(o=>o.tag==='common').newDesktopUrl = v" /></div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--South America-->
                                        <div v-if="arry_aac.currencyCategories.some(o=>o.tag==='southAmerica')">
                                            <div>{{getLanguage["GLU"]["SA"]}}</div>
                                            <div>
                                                <span class='searchLabel'>{{getLanguage["GLU"]["LU"]}} :</span>
                                                <div class="gameLaunch1">
                                                    <div class="text-center deviceType1">{{getLanguage["GLU"]["C"]}}</div>
                                                    <div class="gameUrl1"><CInput size="sm" :value="arry_aac.currencyCategories.find(o=>o.tag==='southAmerica').desktopUrl" readonly /></div>
                                                </div>
                                                <div class="gameLaunch1">
                                                    <div class="text-center deviceType1">{{getLanguage["GLU"]["N"]}}</div>
                                                    <div class="gameUrl1"><CInput size="sm" :value="arry_aac.currencyCategories.find(o=>o.tag==='southAmerica').newDesktopUrl" @change="v => arry_aac.currencyCategories.find(o=>o.tag==='southAmerica').newDesktopUrl = v" /></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!--DEFAULT-->
                                <div v-else>
                                    <div class="modal-main-content p-0">
                                        <div>
                                            <span class='searchLabel'>{{getLanguage["GLU"]["DLU"]}} :</span>
                                            <div class="gameLaunch1">
                                                <div class="text-center deviceType1">{{getLanguage["GLU"]["C"]}}</div>
                                                <div class="gameUrl1"><CInput size="sm" :value="arry_aac.desktopUrl" readonly /></div>
                                            </div>
                                            <div class="gameLaunch1">
                                                <div class="text-center deviceType1">{{getLanguage["GLU"]["N"]}}</div>
                                                <div class="gameUrl1"><CInput size="sm" :value="arry_aac.newDesktopUrl" @change="v => arry_aac.newDesktopUrl = v" /></div>
                                            </div>
                                        </div>
                                       
                                        <div>
                                            <span class='searchLabel'>{{getLanguage["GLU"]["MLU"]}} :</span>
                                            <div class="gameLaunch1">
                                                <div class="text-center deviceType1">{{getLanguage["GLU"]["C"]}}</div>
                                                <div class="gameUrl1"><CInput size="sm" :value="arry_aac.mobileUrl" readonly /></div>
                                            </div>
                                            <div class="gameLaunch1">
                                                <div class="text-center deviceType1">{{getLanguage["GLU"]["N"]}}</div>
                                                <div class="gameUrl1"><CInput size="sm" :value="arry_aac.newMobileUrl" @change="v => arry_aac.newMobileUrl = v" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style="text-align:center;margin-top:20px" v-if="checkModuleAccess2(constAccessType.edit)">
                                    <CButton color="outline-info" size="sm" @click="saveGameLaunchUrl()" v-if="!bool_isView">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>

                        </CCard>
                    </div>
                </div>

            </transition>
        </div>

        <div v-if="bool_isAMVS">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["ACU"][arry_aac.I > 0? "EACF": "AACF"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddSimple()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol xl="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                          :options="dd_agentgroup"
                                                          :flat="true"
                                                          :defaultExpandLevel="Infinity"
                                                          :clearable="false"
                                                          :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                          v-model="arry_aac['AGIT']"
                                                          :disabled="arry_aac.I > 0"
                                                          ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                    </CCol>
                                    <CCol xl="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["ACU"]["ST"]}} :</label>
                                        <treeselect :multiple="true"
                                                    :options="dd_acuz"
                                                    :limit="1"
                                                    :placeholder="this.utilGetDDLanguage('ACU.ST')"
                                                    :clearable="true"
                                                    v-model="arry_aac['nCuzView']" />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveGameLaunchUrl(true)">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["GLU"]}}</h2>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['CAT']}}</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCategoryOptions"
                                            :options="ddCategoryList"
                                            placeholder
                                            :auto-load-root-options="false"
                                            @input="CategoryNameChange"
                                            v-model="searchCategory" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['PROV']}}</span>
                                <treeselect :multiple="false"
                                            :options="ddProviderList"
                                            :auto-load-root-options="false"
                                            placeholder
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            :load-options="loadProviderOptions"
                                            v-model="searchProvider" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["SMB"]["GLU"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["AG"]["GP"]}}<i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MT"]["BN"]}}</th>
                                <th style="width: 700px;">{{this.getLanguage["CTAB"]["U"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["SMSSP"]["PN"]}}<i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["MT"]["BN"]}}</th>
                                <th style="width: 700px;">{{this.getLanguage["CTAB"]["U"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" ></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_acl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_acl">
                            <td style="padding-top: 12px;padding-bottom: 12px;">{{ CountItem(index+1) }}</td>
                            <td style="padding-top: 12px;padding-bottom: 12px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)" >
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" style="margin-left: 0px" @click="editAgentConfig(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>


                                    <div v-if="checkModuleAccess2(constAccessType.view) && !checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-description" @click="viewAgentConfig(data.I)"></i> <!--here View -->
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.view) && !checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom-tooltip">
                                        <i class="cil-description"></i> <!--here View -->
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td style="padding-top: 12px;padding-bottom: 12px;">{{ getLanguage['GP'][data.ProviderName] }}</td>
                            <td style="padding-top: 12px;padding-bottom: 12px;">{{ data.GroupName ? data.GroupName : getLanguage['GL']['ALL2']}}</td>
                            <td style="padding-top: 12px;padding-bottom: 12px;">
                                <div style="width:700px">
                                    <div v-if="data.ProviderName==='PGSOFT'">
                                        <div class="gameLaunch">
                                            <div class="text-center deviceType">{{getLanguage["ACU"]["DT"]}}</div>
                                            <div class="gameUrl">...</div>
                                        </div>
                                        <div class="gameLaunch mb-0">
                                            <div class="text-center deviceType">{{getLanguage["ACU"]["MB"]}}</div>
                                            <div class="gameUrl">...</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="gameLaunch">
                                            <div class="text-center deviceType">{{getLanguage["ACU"]["DT"]}}</div>
                                            <div class="gameUrl">{{ data.DesktopUrl ? data.DesktopUrl : '' }}</div>
                                        </div>
                                        <div class="gameLaunch mb-0">
                                            <div class="text-center deviceType">{{getLanguage["ACU"]["MB"]}}</div>
                                            <div class="gameUrl">{{ data.MobileUrl ? data.MobileUrl : '' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import { required, minLength, between, url, requiredIf } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        props: {

        },
        data() {
            return {
                searchCategory: null,
                searchProvider: null,
                ddCategoryList: null,
                ddProviderList: null,
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_isAMVS: false, // Simple Add Modal Visible
                bool_fullLoading: false, // Add Modal Visible
                //sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_isView: false,
                ShowFullAgentConfig: false,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                str_tableSortBy: "PN", //(sort the table col name)
                bool_isSort: false,
                str_FV: [{ F: "AGI" }], //Filter Value
                arry_aac: {},
                arry_acl: [],
                dd_agentgroup: [],//agent group option
                dd_acuz: [],
                dd_gameprovider: [],
                searchAgent: null,
                constAccessType: constAccessType,
                arry_OnOff: {
                    "DGPL": { CV: false, DC: true },
                    "SL": { CV: true, DC: true },
                    "DCC": { CV: false, DC: true },
                    "CCALPN": { CV: false, DC: true },
                    "CCNO": { CV: false, DC: true },
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true },
                    "CDPNO": { CV: true, DC: true },
                    "HMCI": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "LMIAA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "OWB": { CV: false, DC: false },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    "HSCM": { CV: true, DC: false },
                    "HSQRCM": { CV: true, DC: false },
                    "HICSM": { CV: true, DC: false },
                    "SQRCSM": { CV: true, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "HBLPU": { CV: true, DC: false },
                    "LD": { CV: false, DC: true },
                    "DADIF": { CV: false, DC: true },
                    "HMDO": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "FNABAN": { CV: false, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "DODDS": { CV: false, DC: true },
                    "DDNF": { CV: false, DC: false },
                    "MDMIA": { CV: false, DC: true },
                    "HMAN": { CV: false, DC: true },
                    "EAFBFHP": { CV: false, DC: true },
                    "DDLS": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "ECF": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "EFPL": { CV: false, DC: true },
                    "FPDTMB": { CV: true, DC: false },
                    "FPDT": { CV: false, DC: true },
                    "FPMB": { CV: false, DC: true },
                    "ETBN": { CV: false, DC: true },
                    "DTMB": { CV: true, DC: false },
                    "DT": { CV: false, DC: true },
                    "MB": { CV: false, DC: true },
                    "PDO": { CV: false, DC: true },
                    "MD": { CV: true, DC: false },
                    "AD": { CV: false, DC: true },
                    "ADP": { CV: false, DC: true },
                    "HP": { CV: false, DC: true },
                    "OP": { CV: false, DC: true },
                    "EZP": { CV: false, DC: true },
                    "TUP": { CV: false, DC: true },
                    "CT": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "SIPWM": { CV: true, DC: false },
                    "HMSB": { CV: false, DC: true },
                    "DSAB": { CV: false, DC: true },
                    "EASF": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "AFTTFG": { CV: false, DC: true },
                    "HFTGBL": { CV: false, DC: true },
                    "HFTGAL": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "GLIF": { CV: true, DC: true },
                    "HT5DG": { CV: false, DC: true },
                    "HT5J": { CV: false, DC: true },
                    "HT5S": { CV: false, DC: true },
                    "HT5LC": { CV: false, DC: true },
                    "HT5SES": { CV: false, DC: true },
                    "XFU": { CV: false, DC: true },
                    "STP": { CV: false, DC: true },
                    "SUREP": { CV: false, DC: true },
                    "FUP": { CV: false, DC: true },
                    "TMONEY": { CV: false, DC: true },
                    "SMP": { CV: false, DC: true },
                    "U2P": { CV: false, DC: true },
                    "LP": { CV: false, DC: true },
                    "BCP": { CV: false, DC: true },
                    "FPG": { CV: false, DC: true },
                    "PGA": { CV: false, DC: true },
                    "UP": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true }, //Use Register Bank Account Name
                    "HL5GH": { CV: false, DC: true },
                    "HTR": { CV: false, DC: true },
                    "DMAL": { CV: false, DC: true },
                    "DMAR": { CV: false, DC: true },
                    "DMAD": { CV: false, DC: true },
                    "DMAW": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    //"PHONE": { CV: false, DC: true },
                    //"EMAIL": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "EPDN": { CV: false, DC: true },
                    "EPWN": { CV: false, DC: true },
                    "EPPN": { CV: false, DC: true },
                },
                obj_LCC: {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                },
                /*arry_Localised: [],*/
                str_CaptchaOption: "",
                str_PreferredDepositOption: "",
                str_TournamentNavOption: "",
                str_ForgotPasswordLinkOption: "",
                bool_DMSA: false,
                agit: null,
                agentconfig_LS: true,
                agentconfig_RS: false,
                agentconfig_MSS: false,
                agentconfig_BBOS: false,
                agentconfig_CS: false,
            }
        },
        validations: {
            arry_aac: {
            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.GLU';
            var parameters = this.$route.query;
            if (parameters.agi !== undefined) {
                this.agit = parameters.agi;
                this.str_FV[0].FV = parameters.agi.split("-")[1]
            }
            this.getAgentGroup();
            this.getGameLaunchUrls();
            this.getAgentSettingValue();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.ShowFullAgentConfig = !this.getUserInfo.IHAC;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            ...mapActions('UserInfo', ['setUser']),
            onDisableGameProviderLobbiessChanged(event) {
                var that = this;
                that.arry_OnOff.DGPL.CV = event.target.checked;
                if (that.dd_gameprovider.length === 0 && event.target.checked) {
                    if (that.arry_aac.AGI > 0) {
                        this.getGameProviders(that.arry_aac.AGI);
                    } else {
                        that.dd_gameprovider = [];
                    }
                }
            },
            getGameProviders(agi) {
                var that = this;
                this.getDataApi(`/api/dd/inactivatable-provider-lobbies/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_gameprovider = d.dropdownlist;
                        }
                    });
            },
            tickLeadinZero(event, data, type, row) {
                var that = this;
                var index = row - 1;

                for (var i = 0; i < that.arry_aac.LocalisedList.length; i++) {
                    if (i == index) {
                        if (type > 0) {
                            that.arry_aac.LocalisedList[i].LZ = 0;
                            var w_lz = that.arry_aac.LocalisedList[i].PC.substr(1);
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + w_lz;
                        } else {
                            that.arry_aac.LocalisedList[i].LZ = 1;
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + that.arry_aac.LocalisedList[i].PC;
                        }
                    }
                }
            },
            getPreset(data) {
                var w_lz = data.PC.substr(1);

                if (data.LZ > 0) {
                    return data.CC + '' + data.PC;
                } else {
                    return data.CC + '' + w_lz;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ACUZ', 'AGS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.bool_isView = false;
            },
            closeAddSimple() {
                this.bool_isAMVS = !this.bool_isAMVS;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGameLaunchUrls();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getGameLaunchUrls();
            },
            getAgentSettingValue() {
                var that = this;
                this.getDataApi(`/api/dd/acuz/`,
                    function (d, s) {
                        if (s) {
                            that.dd_acuz = d.dropdownlist;


                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            //if (that.dd_agentgroup.length > 0) {

                            //    that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            //}

                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                if (value == "" || value == null || value == undefined) {
                    this.str_FV[0].FV = null;

                }
                else {
                    this.str_FV[0].FV = value.split("-")[1];
                }
            },
            getGameLaunchUrls() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                path += ("&f[RS]=2");

                if (this.searchCategory) {
                    path += ("&f.GCI=" + this.searchCategory);
                }

                if (this.searchProvider) {
                    path += ("&f.GPI=" + this.searchProvider);
                }

                this.getDataApi(`/api/glu/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setACList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setACList(data) {
                this.arry_acl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setAC(data) {
                this.arry_aac = data;
                this.arry_aac.nCuzView = [];
                this.bool_DMSA = false;
                for (var x = 0; x < data.CuzView.length; x++) {
                    this.arry_aac.nCuzView.push(data.CuzView[x].CC);
                }

                if (data.LocalisedList.length > 0) {
                    this.arry_aac.E_CC = data.LocalisedList[0].CC;
                    this.arry_aac.E_PC = "";
                } else {
                    this.arry_OnOff.UPCODE.CV = false;
                    this.arry_aac.E_CC = "";
                    this.arry_aac.E_PC = "";
                }
                this.arry_OnOff = {
                    "DGPL": { CV: false, DC: true },
                    "SL": { CV: false, DC: true },
                    "DCC": { CV: false, DC: true },
                    "CCALPN": { CV: false, DC: true },
                    "CCNO": { CV: false, DC: true },
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: false, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: false, DC: true },
                    "CDPNO": { CV: false, DC: true },
                    "HMCI": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "LMIAA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "OWB": { CV: false, DC: false },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    "HSCM": { CV: false, DC: false },
                    "HSQRCM": { CV: false, DC: false },
                    "HICSM": { CV: false, DC: false },
                    "SQRCSM": { CV: false, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "HBLPU": { CV: false, DC: false },
                    "LD": { CV: false, DC: true },
                    "DADIF": { CV: false, DC: true },
                    "HMDO": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "FNABAN": { CV: false, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "HCDIHO": { CV: false, DC: true },   // Hide Currency Dropdown If Having Only One Option
                    "DWOTT": { CV: false, DC: true },
                    "DODDS": { CV: false, DC: true },
                    "DDNF": { CV: false, DC: false },
                    "MDMIA": { CV: false, DC: true },
                    "HMAN": { CV: false, DC: true },
                    "EAFBFHP": { CV: false, DC: true },
                    "DDLS": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "ECF": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "EFPL": { CV: false, DC: true },
                    "FPDTMB": { CV: true, DC: true },
                    "FPDT": { CV: false, DC: true },
                    "FPMB": { CV: false, DC: true },
                    "ETBN": { CV: false, DC: true },
                    "DTMB": { CV: true, DC: true },
                    "DT": { CV: false, DC: true },
                    "MB": { CV: false, DC: true },
                    "PDO": { CV: false, DC: true },
                    "MD": { CV: false, DC: true },
                    "AD": { CV: false, DC: true },
                    "ADP": { CV: false, DC: true },
                    "HP": { CV: false, DC: true },
                    "OP": { CV: false, DC: true },
                    "EZP": { CV: false, DC: true },
                    "TUP": { CV: false, DC: true },
                    "CT": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "SIPWM": { CV: false, DC: false },  // Show Invalid Phone Waring Message
                    "HMSB": { CV: false, DC: true },
                    "DSAB": { CV: false, DC: true },
                    "EASF": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "AFTTFG": { CV: false, DC: true },
                    "HFTGBL": { CV: false, DC: true },
                    "HFTGAL": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "GLIF": { CV: false, DC: true },
                    "HT5DG": { CV: false, DC: true },
                    "HT5J": { CV: false, DC: true },
                    "HT5S": { CV: false, DC: true },
                    "HT5LC": { CV: false, DC: true },
                    "HT5SES": { CV: false, DC: true },
                    "XFU": { CV: false, DC: true },
                    "STP": { CV: false, DC: true },
                    "SUREP": { CV: false, DC: true },
                    "FUP": { CV: false, DC: true },
                    "TMONEY": { CV: false, DC: true },
                    "SMP": { CV: false, DC: true },
                    "U2P": { CV: false, DC: true },
                    "LP": { CV: false, DC: true },
                    "BCP": { CV: false, DC: true },
                    "FPG": { CV: false, DC: true },
                    "PGA": { CV: false, DC: true },
                    "UP": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "HL5GH": { CV: false, DC: true },
                    "HTR": { CV: false, DC: true },
                    "DMAL": { CV: false, DC: true },
                    "DMAR": { CV: false, DC: true },
                    "DMAD": { CV: false, DC: true },
                    "DMAW": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    //"PHONE": { CV: false, DC: true },
                    //"EMAIL": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "EPDN": { CV: false, DC: true },
                    "EPWN": { CV: false, DC: true },
                    "EPPN": { CV: false, DC: true },

                };

                for (const [key, value] of Object.entries(this.arry_OnOff)) {
                    if (value.DC) {
                        if (this.arry_aac.nCuzView.includes(key)) {
                            value.CV = true;
                            if (key == "CCALPN" || key == "CCNO" || key == "DCC") {
                                this.str_CaptchaOption = key;
                            }
                            else if (key == "MD" || key == "AD" || key == "ADP" || key == "HP" || key == "OP" || key == "EZP" || key == "TUP" || key == "CT" || key == "XFU") {
                                //debugger;
                                this.str_PreferredDepositOption = key;
                            }
                            else if (key == "DTMB" || key == "DT" || key == "MB") {
                                this.str_TournamentNavOption = key;
                            }
                            else if (key == "FPDTMB" || key == "FPDT" || key == "FPMB") {
                                this.str_ForgotPasswordLinkOption = key;
                            }
                            else if (key == "DGPL") {
                                this.getGameProviders(data.AGI)
                            }
                        }
                    }
                    else {
                        if (!this.arry_aac.nCuzView.includes(key)) {
                            value.CV = true;
                        }
                    }
                }

                if (this.arry_aac.InactiveDays == -1) {
                    this.arry_aac.InactiveDays = 60;
                }
                if (this.arry_OnOff.DMAL.CV || this.arry_OnOff.DMAR.CV || this.arry_OnOff.DMAD.CV || this.arry_OnOff.DMAW.CV) {
                    this.bool_DMSA = true;
                }
                this.bool_isAMV = true;
            },

            addAgentConfig(isSimple = false) {
                this.showAgentConfig(1);
                this.arry_aac = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 60,
                    Rate: 0,
                    DisabledProviderLobbies: []
                };

                this.dd_gameprovider = [];

                this.arry_OnOff = {
                    "DGPL": { CV: false, DC: true },
                    "SL": { CV: true, DC: true },
                    "DCC": { CV: false, DC: true },
                    "CCALPN": { CV: false, DC: true },
                    "CCNO": { CV: false, DC: true },
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true },
                    "CDPNO": { CV: true, DC: true },
                    "HMCI": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "LMIAA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "OWB": { CV: false, DC: false },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    "HSCM": { CV: true, DC: false },
                    "HSQRCM": { CV: true, DC: false },
                    "HICSM": { CV: true, DC: false },
                    "SQRCSM": { CV: true, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "HBLPU": { CV: true, DC: false },
                    "LD": { CV: false, DC: true },
                    "DADIF": { CV: false, DC: true },
                    "HMDO": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "FNABAN": { CV: false, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "DODDS": { CV: false, DC: true },
                    "DDNF": { CV: false, DC: false },
                    "MDMIA": { CV: false, DC: true },
                    "HMAN": { CV: false, DC: true },
                    "EAFBFHP": { CV: false, DC: true },
                    "DDLS": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "ECF": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "EFPL": { CV: true, DC: true },
                    "FPDTMB": { CV: true, DC: false },
                    "FPDT": { CV: false, DC: true },
                    "FPMB": { CV: false, DC: true },
                    "ETBN": { CV: true, DC: true },
                    "DTMB": { CV: true, DC: false },
                    "DT": { CV: false, DC: true },
                    "MB": { CV: false, DC: true },
                    "PDO": { CV: false, DC: true },
                    "MD": { CV: true, DC: false },
                    "AD": { CV: false, DC: true },
                    "ADP": { CV: false, DC: true },
                    "HP": { CV: false, DC: true },
                    "OP": { CV: false, DC: true },
                    "EZP": { CV: false, DC: true },
                    "TUP": { CV: false, DC: true },
                    "CT": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "SIPWM": { CV: true, DC: false },
                    "HMSB": { CV: false, DC: true },
                    "DSAB": { CV: false, DC: true },
                    "EASF": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "AFTTFG": { CV: false, DC: true },
                    "HFTGBL": { CV: false, DC: true },
                    "HFTGAL": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "GLIF": { CV: true, DC: true },
                    "HT5DG": { CV: false, DC: true },
                    "HT5J": { CV: false, DC: true },
                    "HT5S": { CV: false, DC: true },
                    "HT5LC": { CV: false, DC: true },
                    "HT5SES": { CV: false, DC: true },
                    "XFU": { CV: false, DC: true },
                    "STP": { CV: false, DC: true },
                    "SUREP": { CV: false, DC: true },
                    "FUP": { CV: false, DC: true },
                    "TMONEY": { CV: false, DC: true },
                    "SMP": { CV: false, DC: true },
                    "U2P": { CV: false, DC: true },
                    "LP": { CV: false, DC: true },
                    "BCP": { CV: false, DC: true },
                    "FPG": { CV: false, DC: true },
                    "UP": { CV: false, DC: true },
                    "PGA": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "HL5GH": { CV: false, DC: true },
                    "HTR": { CV: false, DC: true },
                    "DMAL": { CV: false, DC: true },
                    "DMAR": { CV: false, DC: true },
                    "DMAD": { CV: false, DC: true },
                    "DMAW": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    //"PHONE": { CV: false, DC: true },
                    //"EMAIL": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "EPDN": { CV: false, DC: true },
                    "EPWN": { CV: false, DC: true },
                    "EPPN": { CV: false, DC: true },

                };

                this.obj_LCC = {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                };

                this.arry_aac.nCuzView = [];
                if (isSimple) {
                    this.bool_isAMVS = true;
                    this.bool_CV = false;
                }
                else {
                    this.bool_isAMV = true;
                    this.bool_CV = false;
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.arry_aac.AGIT = this.dd_agentgroup[0].id;
                    }
                }
                this.bool_DMSA = false;
                this.searchAgent = null;
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.arry_aac[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MT"][langKey]);
                    }
                }

            },
            loadCategoryOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.ddCategoryList = d.dropdownlist;
                        }
                        else {
                            that.ddCategoryList = null;
                        }

                        callback();
                    });
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/`,

                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }
                            that.ddProviderList = d.dropdownlist;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            saveGameLaunchUrl(game) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                this.bool_CV = true;

                this.$v.arry_aac.$touch();
                if (!this.$v.arry_aac.$error) {
                    var that = this;
                    this.arry_aac['updatedById'] = this.getUserInfo.AID;
                    this.arry_aac['updatedBy'] = this.getUserInfo.U;
                    this.postDataApi(`/api/glu/s`, this.arry_aac,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (d.S) {
                                that.bool_isAMV = false;
                                that.bool_isAMVS = false;
                                that.getGameLaunchUrls();
                                that.$root.UserInfo.getInfoApi(that);
                            } else {
                                that.showErrorMessage("Error", d.ERR[0].ED, null);
                            }
                        });
                }
                else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["arry_aac"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editAgentConfig(launchUrl, bool_copy = false) {
                //this.showAgentConfig(1);
                this.bool_fullLoading = true;
                this.bool_CV = false;

                const currencyCategories = [];
                switch (launchUrl.ProviderName) {
                    case 'PGSOFT':
                        for (const curr of launchUrl.CurrencyData) {
                            const currencyCategory = currencyCategories.find(o => o.tag === curr.Tag);
                            if (!currencyCategory) {
                                currencyCategory = {
                                    tag: curr.Tag,
                                    desktopUrl: curr.DesktopUrl,
                                    mobileUrl: curr.MobileUrl,
                                    newDesktopUrl: curr.DesktopUrl,
                                    newMobileUrl: curr.MobileUrl,
                                    currencies: []
                                };
                                currencyCategories.push(currencyCategory);
                            }

                            currencyCategory.currencies.push({
                                currencyId: curr.CurrencyId,
                                isoCode: curr.ISOCode
                            });
                        }
                        break;
                }

                this.arry_aac = {
                    gameProviderId: launchUrl.GameProviderId,
                    providerName: launchUrl.ProviderName,
                    agentGroupId: launchUrl.AgentGroupId,
                    desktopUrl: launchUrl.DesktopUrl,
                    mobileUrl: launchUrl.MobileUrl,
                    newDesktopUrl: launchUrl.DesktopUrl,
                    newMobileUrl: launchUrl.MobileUrl,
                    currencyCategories: currencyCategories
                };

                this.bool_isAMV = true;
                this.bool_fullLoading = false;

                //this.getDataApi(`/api/glu/s/${data.GameProviderId}`,
                //    function (d, s) {
                //        that.bool_fullLoading = false;
                //        if (s) {
                //            that.setAC(d.D);
                //            that.bool_isAMV = false;

                //            if (that.arry_aac.AGI != 0) {
                //                that.arry_aac.AGIT = that.arry_aac.AGI;
                //                that.searchAgent = ["3-" + that.arry_aac.AGI];
                //            }
                //            that.bool_isAMV = true;
                //        }
                //        if (bool_copy == true) {
                //            that.searchAgent = null;
                //            that.arry_aac.I = 0;
                //        }
                //    });
            },
            CategoryNameChange(value) {
                this.ddProviderList = null;
                this.searchProvider = null;

                if (value != undefined && value > 0) {
                    var that = this;

                    this.getDataApi(`/api/dd/gameProvByCatId/` + value,

                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                                }

                                that.ddProviderList = d.dropdownlist;
                            }
                            else {
                                that.ddProviderList = null;
                            }
                        });

                }

            },
            viewAgentConfig(id) {
                this.bool_fullLoading = true;
                this.bool_CV = false;
                this.bool_isView = true;
                var that = this;
                this.getDataApi(`/api/acuz/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setAC(d.D);
                            that.bool_isAMV = false;
                            if (that.arry_aac.AGI != 0) {
                                that.arry_aac.AGIT = that.arry_aac.AGI;
                                that.searchAgent = ["3-" + that.arry_aac.AGI];
                            }
                            that.bool_isAMV = true;
                        }
                    });
            },
            selectAgentOptions(value, instanceId) {
                var temp = "";

                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.arry_aac['AGIT'] = temp;

                if (temp > 0) {
                    this.getGameProviders(temp);
                } else {
                    this.dd_gameprovider = [];
                }
                //this.sensBtn = ((this.isSENS == 1 && this.arry_aac['AGIT'] != this.curAGI) ? true : false);
            },
            AFTTFG(isEnable) {
                this.arry_OnOff["HFTGBL"].CV = isEnable
                this.arry_OnOff["HFTGAL"].CV = isEnable
            },
            removeAgentConfig(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            agi: data.AGI,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/acuz/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getGameLaunchUrls();
                                    that.$root.UserInfo.getInfoApi(that);
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getGameLaunchUrls();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            removeLocaliseList(index) {
                this.$delete(this.arry_aac.LocalisedList, index);
                this.$forceUpdate();
            },
            addPrefix() {
                var exist = false;
                var isValid = true;
                var clearRequired = true;
                var isEPrefix = this.arry_OnOff.UPCODE.CV;
                var CountryCode = this.arry_aac.E_CC;
                var PrefixCode = this.arry_aac.E_PC;
                var emptyPrefix = false;

                if (CountryCode == "") {
                    clearRequired = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["CCODE"]), 1000);
                }

                if (isEPrefix == true) {
                    if (PrefixCode == "") {
                        clearRequired = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["PCODE"]), 1000);
                    } else {
                        if (this.arry_aac.LocalisedList.length > 0) {
                            for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                                if (this.arry_aac.LocalisedList[i].PC == "") {
                                    emptyPrefix = true;
                                    break;
                                }
                            }

                            if (emptyPrefix) {
                                clearRequired = false;
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                            }
                        }
                    }
                }

                if (clearRequired == true) {

                    var str_CC = CountryCode[0];

                    if (str_CC == "+") {
                        CountryCode = CountryCode.substr(1);
                    }

                    if (!CountryCode.match((/^[0-9]*$/))) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["CCODE"]), 1000);
                        isValid = false;
                    }

                    if (PrefixCode != "") {
                        if (!PrefixCode.match((/^[0-9]*$/))) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["PCODE"]), 1000);
                            isValid = false;
                        }
                    }

                    if (isValid == true) {

                        for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {

                            if (this.arry_aac.LocalisedList[i].PC) {
                                if (this.arry_aac.LocalisedList[i].PC == PrefixCode) {
                                    exist = true;
                                    break;
                                }
                            }

                            //if (this.arry_aac.LocalisedList[i].CC != "") {
                            //    CountryCode = this.arry_aac.LocalisedList[i].CC;
                            //}
                        }
                        if (exist) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["ACO"]["PCODE"]), 1000);
                        }
                        else {

                            var w_lz = PrefixCode.substr(1);

                            this.obj_LCC = {
                                CC: CountryCode,
                                PC: PrefixCode,
                                LZ: 0,
                                PN: CountryCode + '' + w_lz
                            }
                            this.arry_aac.LocalisedList.push(this.obj_LCC);
                        }

                    }
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            disableMemberSite(value) {
                this.bool_DMSA = value;
                this.arry_OnOff.DMAL.CV = value;
                this.arry_OnOff.DMAR.CV = value;
                this.arry_OnOff.DMAD.CV = value;
                this.arry_OnOff.DMAW.CV = value;
            },
            renderTitle(id) {
                if (this.bool_isView) {
                    return this.getLanguage["ACU"]["VACF"];
                }
                else {
                    return this.getLanguage["ACU"][id > 0 ? "EACF" : "AACF"];
                }

            },
            renderStyle() {
                if (this.bool_isView) {
                    return "pointer-events:none";
                }
            },
            showAgentConfig(value) {
                this.agentconfig_LS = false;
                this.agentconfig_RS = false;
                this.agentconfig_MSS = false;
                this.agentconfig_BBOS = false;
                this.agentconfig_CS = false;
                switch (value) {
                    case 1:
                        this.agentconfig_LS = true;
                        break;
                    case 2:
                        this.agentconfig_RS = true;
                        break;
                    case 3:
                        this.agentconfig_MSS = true;
                        break;
                    case 4:
                        this.agentconfig_BBOS = true;
                        break;
                    case 5:
                        this.agentconfig_CS = true;
                        break;
                }
            },
            disableRegWithPhone(value) {
                this.arry_OnOff.REGWPHONE.CV = value;
                this.arry_OnOff.ULPN.CV = !value;
                this.arry_OnOff.UPCODE.CV = !value;
                this.arry_OnOff.DOTPV.CV = !value;
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            }
        },
    }
</script>

<style>

    .gameLaunch {
        display: grid;
        grid-template-columns:70px 630px;
        margin-bottom: 3px;
        border: 1px solid #d8dbe0;
        padding: 1px;
        border-radius: 2px;
    }

    .deviceType {
        width: 70px;
        padding: 5px;
        background-color: rgb(231, 233, 250);
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
    }

    .gameUrl {
        max-width: 630px;
        padding: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .gameLaunch1 {
        display: grid;
        grid-template-columns: 70px auto;
        margin-bottom: 3px;
        padding: 1px;
        border-radius: 2px;
    }

    .deviceType1 {
        width: 70px;
        background-color: rgb(231, 233, 250);
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
    }

    .gameUrl1 {
        max-width: auto;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/GameLaunchUrl.vue